import ATabs from './Tabs';
export default ATabs;


// WEBPACK FOOTER //
// ./src/packages/Tabs/index.js